import { render, staticRenderFns } from "./apsnew.vue?vue&type=template&id=1f94acc7&scoped=true&"
import script from "./apsnew.vue?vue&type=script&lang=js&"
export * from "./apsnew.vue?vue&type=script&lang=js&"
import style0 from "./apsnew.vue?vue&type=style&index=0&id=1f94acc7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f94acc7",
  null
  
)

export default component.exports